import { useState, ReactNode, useRef, useEffect } from 'react'

interface TooltipProps {
  children: ReactNode
  content: string
}

const Tooltip = ({ children, content }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const tooltipRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  
  useEffect(() => {
    if (showTooltip && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      const tooltipWidth = 300 // Match CSS width
      const tooltipLeft = rect.left + rect.width / 2 - tooltipWidth / 2
      const tooltipTop = rect.top - 8 // 8px gap
      
      // Adjust if tooltip would go off screen
      const adjustedLeft = Math.max(10, Math.min(tooltipLeft, window.innerWidth - tooltipWidth - 10))
      const adjustedTop = Math.max(10, tooltipTop)
      
      setPosition({
        top: adjustedTop,
        left: adjustedLeft
      })
    }
  }, [showTooltip])
  
  return (
    <div 
      ref={containerRef}
      className="tooltip"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      {children}
      {showTooltip && (
        <div 
          ref={tooltipRef}
          className="tooltip-text"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: 'translateY(-100%)'
          }}
        >
          {content}
        </div>
      )}
    </div>
  )
}

export default Tooltip